var _rect, _path, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.5 28.3333H12.5C12.1583 28.3333 11.875 28.05 11.875 27.7083C11.875 27.3667 12.1583 27.0833 12.5 27.0833H27.5C27.8417 27.0833 28.125 27.3667 28.125 27.7083C28.125 28.05 27.8417 28.3333 27.5 28.3333Z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.85 12.9C24.2333 11.2833 22.65 11.2417 20.9916 12.9L19.9833 13.9083C19.9 13.9917 19.8666 14.125 19.9 14.2417C20.5333 16.45 22.3 18.2167 24.5083 18.85C24.5416 18.8583 24.575 18.8667 24.6083 18.8667C24.7 18.8667 24.7833 18.8333 24.85 18.7667L25.85 17.7583C26.675 16.9417 27.075 16.15 27.075 15.35C27.0833 14.525 26.6833 13.725 25.85 12.9Z",
    fill: "#475467"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0083 19.6083C22.7666 19.4917 22.5333 19.375 22.3083 19.2417C22.125 19.1333 21.95 19.0167 21.775 18.8917C21.6333 18.8 21.4666 18.6667 21.3083 18.5333C21.2916 18.525 21.2333 18.475 21.1666 18.4083C20.8916 18.175 20.5833 17.875 20.3083 17.5417C20.2833 17.525 20.2416 17.4667 20.1833 17.3917C20.1 17.2917 19.9583 17.125 19.8333 16.9333C19.7333 16.8083 19.6166 16.625 19.5083 16.4417C19.375 16.2167 19.2583 15.9917 19.1416 15.7583C19.025 15.5083 18.9333 15.2667 18.85 15.0417L13.6166 20.275C13.5083 20.3833 13.4083 20.5917 13.3833 20.7333L12.9333 23.925C12.85 24.4917 13.0083 25.025 13.3583 25.3833C13.6583 25.675 14.075 25.8333 14.525 25.8333C14.625 25.8333 14.725 25.825 14.825 25.8083L18.025 25.3583C18.175 25.3333 18.3833 25.2333 18.4833 25.125L23.7166 19.8917C23.4833 19.8083 23.2583 19.7167 23.0083 19.6083Z",
    fill: "#475467"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    stroke: "#E4E4E7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.4ba8afa592c9a61cfd7e70fc3a8c99fb.svg";
export { ForwardRef as ReactComponent };